/* Dependencies */
import styled from 'styled-components';

/* Icons */
import { ReactComponent as DropdownBtn } from 'images/icons/delete_dots.svg';

export const DirectorContainer = styled.div.attrs(() => ({
  className: 'DirectorItem',
}))`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, 40px);
  column-gap: 10px;
  align-items: center;

  border: 1px solid ${({ theme }) => theme.colors.shadeMediumLight};
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.shadeDark};
  margin-bottom: 10px;
  padding: 10px;
  transition: 0.5s;
  position: relative;

  .StyledDropdown {
    width: 50px;
    position: absolute;
    right: 0;
    top: 0;
  }

  ${({ theme }) => theme.breakPoints.desktop} {
    grid-template-columns: 2.2fr 1.1fr 0.8fr 1.08fr 0.3fr;
    grid-template-rows: 64px;
    row-gap: 10px;
    align-items: center;
    padding: 0;

    .StyledDropdown {
      width: 50px;
      position: unset;

      .DropdownRemove {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 100%;
      }
    }
  }

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.physicalLight30};
    color: ${({ theme }) => theme.colors.darkGray};
  }
`;

export const Name = styled.div.attrs(() => ({
  className: 'DirectorName',
}))`

  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;

  & p {
    margin-left: 16px;
    max-width: 170px;
    word-wrap: break-word;
  }

  ${({ theme }) => theme.breakPoints.desktop} {
    padding: 0 0 0 10px;
    font-size: 16px;
    height: 100%;
    width: 100%;

    & p {
      max-width: 320px;
    }
  }
`;

export const DirectorImg = styled.img.attrs(() => ({
  className: 'DirectorImage',
  alt: 'Director Image',
}))`
  border-radius: 50%;
  object-fit: cover;
  overflow: hidden;
  height: 40px;
  width: 40px;
`;

export const AssignedCenters = styled.div.attrs(() => ({
  className: 'DirectorAssignedCenters',
}))`
  cursor: pointer;
  font-size: 14px;
  margin-left: 57px;
  max-width: 150px;
  ${({ theme }) => theme.breakPoints.desktop} {
    margin-left: -5px;
    & span {
      display: none;
    }
  }
`;

export const Role = styled.div.attrs(() => ({
  className: 'DirectorRole',
}))`
  cursor: pointer;
  font-size: 14px;
  margin-left: 57px;

  span {
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ${({ theme }) => theme.breakPoints.desktop} {
    margin-left: -5px;
  }
`;
export const Email = styled.div.attrs(() => ({
  className: 'DirectorEmail',
}))`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  margin-left: 57px;

  ${({ theme }) => theme.breakPoints.desktop} {
    margin-left: -5px;
  }
`;

export const StyledDropdown = styled.div.attrs(() => ({
  className: 'StyledDropdown',
}))`
  ${({ theme }) => theme.breakPoints.desktop} {
    display: flex;
    align-items: center;
    justify-content: center;

    min-width: 50px;
    min-height: 50px;
  }
`;

export const DropdownContainer = styled.div.attrs({
  className: 'DropdownContainer',
})`
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  & span {
    color: ${({ theme }) => theme.colors.shadeDark};
    font-size: 14px;
    padding: 7px 15px;
    text-align: left;
    width: 100%;

    &.delete {
      color: ${({ theme }) => theme.colors.health} !important;
    }
  }

  & span:hover {
    background-color: #0086d810;
    color: ${({ theme }) => theme.colors.darkGray};
    cursor: pointer;
  }

  @media only screen and (max-width: 600px) {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 16px;
    width: 100%;
    z-index: 11000;
  }

  ${({ theme }) => theme.breakPoints.tablet} {
    border: 1px solid ${({ theme }) => theme.colors.shadeMediumLight};
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 #00000015;
    min-width: 157px;
    padding: 9px 0;
  }
`;

export const Dots = styled(DropdownBtn).attrs(() => ({
  className: 'DropdownButton',
}))`
  height: 50px;
`;

export const CenterListEmpty = styled.div.attrs(() => ({
  className: 'ListEmptyState',
}))`
  display: flex;
  align-items: center;
  justify-content: center;

  color: ${({ theme }) => theme.colors.shadeMediumDark};
  font-size: 16px;
  margin: 100px auto;
`;

export const Overlay = styled.div.attrs(() => ({ className: 'DarkOverlay' }))`
  background-color: ${({ theme }) => theme.colors.blackAlpha};

  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  height: 100vh;
  width: 100vw;
  z-index: 10000;

  ${({ theme }) => theme.breakPoints.tablet} {
    display: none;
  }
`;

export const CoverLetter = styled.div.attrs(() => ({
  className: 'CoverLetter',
}))`
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  border-radius: 50%;
  object-fit: cover;
  overflow: hidden;
  height: 40px;
  width: 40px;
  min-width: 40px;
  color: #fff;
  background-color: #cea8ef;
  text-transform: uppercase;
`;
